export default __webpack_public_path__ + "static/media/Soulscream Necklace.f1084c65.jpg";